<template>
    <div id="basic-info" class="card">
        <div class="card-header">
            <h5>Perguntas Frequentes</h5>
        </div>
        <div class="card-body pt-0">
            <div class="row">
                <div class="mx-auto col-md-12">
                    <div id="accordion" class="accordion">
                        <accordion-item v-for="(faq, index) in groupFaq" :key=" faq.faq_group_id" :accordion-id="index + faq.faq_group_id" :collapse-id="faq.faq_group_id">
                            <template #question>{{ faq.faq_group }}</template>
                            <template #answer>
                                <div v-for="(item, itemIndex) in faq.items" :key="itemIndex">
                                    <div class="mt-4">
                                        <b v-html="formatText(item.title)"></b>
                                    </div>
                                    <div v-html="formatText(item.content)" class="mt-2"></div>
                                </div>
                            </template>
                        </accordion-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import AccordionItem from "./AccordionItem.vue";
import faq from "../../../../../assets/js/faq.json";
import { onMounted, ref } from "vue";

const groupFaq = ref([]);

const formatText = (text) => {
    return text.replace(/\r?\n/g, '<br>');
};

onMounted(() => {
    teste();
});

const teste = () => {
    if (Array.isArray(faq)) {
        const groupedArray = faq.reduce((agg, current) => {
            agg.push({
                faq_group_id: current[0].faq_group_id,
                faq_group: current[0].faq_group,
                items: current
            });
            return agg;
        }, []);
        groupFaq.value = groupedArray;
        console.log(groupedArray);
    }
};
</script>

<style>
.accordion-button {
    color: #4F097B !important;
}
</style>
